const mixin = {

  methods: {
    createSimulation () {
      this.$store.dispatch('prompt/prompt', {
        title: 'Ajout simulation',
        label: 'Nom de la simulation',
        okText: 'Créer'
      })
        .then((resultat) => {
          if (resultat !== false) {
            this.$store.dispatch('createSimulation', {
              idExploitation: this.idExploitation,
              nom: resultat
            })
              .then(newId => this.$router.push({ name: 'simulation', params: { idExploitation: this.idExploitation, idSimulation: newId } }))
          }
        })
    },

    duplicateSimulation (simulation) {
      this.$store.dispatch('prompt/prompt', {
        title: 'Duplication simulation',
        label: 'Nom de la simulation',
        okText: 'Dupliquer',
        text: simulation.nom + ' - copie'
      })
        .then((resultat) => {
          if (resultat !== false) {
            this.$store.dispatch('duplicateSimulation', {
              idExploitation: this.idExploitation,
              idSimulation: simulation.id_simulation,
              nom: resultat
            })
              .then(newId => this.$router.push({ name: 'simulation', params: { idExploitation: this.idExploitation, idSimulation: newId } }))
          }
        })
    }
  }
}

export default mixin
